import { useAuth } from "@clerk/clerk-react";
import useSWR from "swr";
import { TAccount } from "../types/Accounts";
import { apiPost, fetcher } from "../utils/axios";

const useAccounts = () => {
  const { getToken } = useAuth();

  const { data, error, mutate } = useSWR(`/accounts`, async (url) => {
    const token = await getToken();
    return fetcher(url, token);
  });

  const createAccount = async (name: string, adminEmail: string) => {
    const token = await getToken();
    return apiPost(`/accounts`, { name, adminEmail }, token);
  };

  return {
    accounts: (data as TAccount[]) || [],
    isLoading: !error && !data,
    isError: error,
    createAccount,
    mutate,
  };
};

export { useAccounts };
